import { useCallback, useEffect, useRef } from 'react';

import { useOptimalState } from './useOptimalState';

const DEFAULT_TIMEOUT = 2000;

const eventsList: Array<keyof HTMLElementEventMap> = [
    'mousedown',
    'mousemove',
    'scroll',
    'keydown',
    'scroll',
    'touchstart',
];

export const useUserActivity = (isEnabled = true) => {
    const [isUserActive, setIsUserActive] = useOptimalState(true);
    const timerRef = useRef<number>();

    const stopTimer = useCallback(() => {
        clearTimeout(timerRef.current);
    }, []);

    const startTimer = useCallback(() => {
        timerRef.current = window.setTimeout(() => setIsUserActive(false), DEFAULT_TIMEOUT);
    }, [setIsUserActive]);

    const resetIsUserActive = useCallback(() => {
        stopTimer();
        startTimer();
        setIsUserActive(true);
    }, [setIsUserActive, startTimer, stopTimer]);

    useEffect(() => {
        setIsUserActive(true);
        stopTimer();

        if (isEnabled) {
            startTimer();

            eventsList.forEach((eventName) => {
                document.body.addEventListener(eventName, resetIsUserActive);
            });

            return () => {
                eventsList.forEach((eventName) => {
                    document.body.removeEventListener(eventName, resetIsUserActive);
                });
            };
        }
    }, [isEnabled, resetIsUserActive, setIsUserActive, startTimer, stopTimer]);

    return isUserActive;
};
